import { useSelector } from 'react-redux';
import { defaultFlux, detectActiveFlux, getStepsConfig } from '../../../utils/fluxes';

export const getStepsListV2 = (steps) => Object.keys(steps);

export const getStepsList = (steps) => {
  return steps
    .map((module) => {
      return module.moduleSteps;
    })
    .flat();
};

export const getModuleName = (steps, stepName) => {
  const module = steps.find((_module) => {
    return _module.moduleSteps.find((step) => step === stepName);
  });
  return module && module.moduleName;
};

export const getModuleNameV2 = (_stepsV1, _stepNameV1, stepsV2, stepNameV2) =>
  stepsV2[stepNameV2].module;
/**
 * useActiveFluxSteps
 * @description custom hook that returns the steps of the active flux
 * @returns {array} steps
 */
export const useActiveFluxSteps = () => {
  const fluxes = useSelector((state) => state.wizard.fluxes);
  const activeFlux = detectActiveFlux() || defaultFlux;

  return getStepsConfig(fluxes, activeFlux) || [];
};
